import { render, staticRenderFns } from "./SiteAccordionContainer.vue?vue&type=template&id=9d3afb22&scoped=true"
import script from "./SiteAccordionContainer.vue?vue&type=script&lang=js"
export * from "./SiteAccordionContainer.vue?vue&type=script&lang=js"
import style0 from "./SiteAccordionContainer.vue?vue&type=style&index=0&id=9d3afb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3afb22",
  null
  
)

export default component.exports